import React from 'react';

const Hero: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center bg-prussian-blue overflow-hidden">
      {/* Beautiful blue gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-prussian-blue via-lapis-lazuli to-cerulean"></div>
      
      {/* Floating background decorations */}
      <div className="absolute top-20 right-20 w-72 h-72 bg-celestial-blue/10 rounded-full blur-3xl float"></div>
      <div className="absolute bottom-32 left-20 w-96 h-96 bg-alice-blue/10 rounded-full blur-3xl float" style={{animationDelay: '2s'}}></div>
      
      {/* Content */}
      <div className="container mx-auto px-4 md:px-6 relative z-10 max-w-6xl">
        <div className="max-w-5xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center bg-cerulean/20 border border-celestial-blue/30 text-alice-blue px-4 md:px-8 py-2 md:py-4 rounded-full text-xs md:text-sm font-medium mb-6 md:mb-10 fade-in">
            مدرسة معتمدة من هيئة الطرق والمواصلات
          </div>

          {/* Main heading */}
          <h1 className="text-3xl md:text-6xl lg:text-7xl font-bold text-white leading-tight md:leading-[1.2] mb-6 md:mb-10 px-2 fade-in fade-in-delay-1">
            القيادة ليست مجرد مهارة
            <br />
            بل هي فن الثقة بالنفس
          </h1>
          
          {/* Subtitle */}
          <p className="text-lg md:text-2xl lg:text-3xl text-alice-blue/90 mb-8 md:mb-16 max-w-4xl mx-auto leading-relaxed px-4 fade-in fade-in-delay-2">
            في مدرسة المميز نحولكِ من مبتدئة إلى قائدة واثقة تقود بمهارة وثقة تامة
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 md:gap-8 justify-center items-center fade-in fade-in-delay-3">
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-celestial-blue hover:bg-celestial-blue/90 text-white font-bold py-3 md:py-5 px-6 md:px-12 rounded-full text-base md:text-xl transition-all duration-300 shadow-lg scale-hover"
            >
              ابدئي رحلتكِ الآن
            </button>
            <button 
              onClick={() => scrollToSection('journey')}
              className="border-2 border-alice-blue/30 text-alice-blue hover:bg-alice-blue/10 font-medium py-3 md:py-5 px-6 md:px-12 rounded-full text-base md:text-xl transition-all duration-300 scale-hover"
            >
              استكشفي الحصص
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 